import React, { useState } from 'react'
import GroupStats from './GroupStats'
import TableNav from '../Table/TableNav'
import Card from '../../../common/card/Card'
import { useParams } from 'react-router-dom'
import { QueryClient, useQuery } from '@tanstack/react-query'
import Loader from '../../../common/loader/Loader'
import { useGroupDashboardContext } from '../GroupDashboardContext'

const ReportingGroup = ({ teamData, siteOptionsData, teamOptionsData }) => {
    const params = useParams()
    const teamId = params.team_id
    const [ responseMessage, setResponseMessage ] = useState('')
    const { filtersData } = useGroupDashboardContext()

    const queryClient = new QueryClient()
    const {
      isLoading,
      isPending,
      isFetching,
      isError,
      error,
      data } = useQuery({
      queryKey: ['group-report-snapshot'],
      queryFn: requestGroupReport,
      refetchOnWindowFocus: false
    }, queryClient)
    
    async function requestGroupReport() {
      const {
        group_dashboard: { nonce, root }
      } = window
      try {
        const resp = await fetch(`${root}/group-report-snapshot?team_id=${teamId}&team_type=${teamData.team_type}`, {
          method: 'GET',
          headers: {
            'X-WP-Nonce': nonce,
            'Content-type': "application/json"
          },
          credentials: 'same-origin',
          processData: false,
          contentType: false,
        })
        if (!resp.ok) {
          throw new Error( resp.statusText )
        }
        return await resp.json();
      } catch (error) {
        console.log(error);
        setResponseMessage( error.toString() )
        return false
      }
    }

    if( isLoading || isPending || isFetching ){
      return (
        <Loader type='spinner-dual-ring'/>
      )
    }
  
    if( isError ){
      return (
        <Card> 
          <strong> { error.message } </strong> 
        </Card>
      )
    }

    return (
      <>
          {
            responseMessage && responseMessage !== ''
            ? <Card> 
                <strong>{ responseMessage }</strong> 
              </Card>
            : data &&
              <>
                
                  <Card title={ filtersData.reports?.group_stats_label }>
                    <div className='msync-card__body'>
                      <GroupStats groupStats={data} />
                    </div>
                  </Card>
                  <Card>
                    <TableNav groupData={data} teamData={teamData} siteOptionsData={siteOptionsData} />
                  </Card>
              </>
          }
        </>
    )
}

export default ReportingGroup
